<template>
    <div v-loading="loading" class="user-search">
      <el-card class="box-card" v-if="listData">
        <h3 slot="header" class="clearfix">
          系统数据M
        </h3>
        <div>
          <span>系统M总锁仓</span>
          {{ listData.mCoinTokenInfo.systemTotalLock }}
        </div>
        <div>
          <span>系统M总余额</span>
          {{ listData.mCoinTokenInfo.systemTotalMBalance }}
        </div>
        <div>
          <span>链上M总额</span>
          {{ listData.mCoinTokenInfo.chainTotalMAmount }}
        </div>
        <div>
          <span>链上M总额（系统账户）</span>
          {{ listData.mCoinTokenInfo.sysChainTotalMAmount }}
        </div>
        <div>
          <span>流通中的总M</span>
          {{ listData.mCoinTokenInfo.mCirculatingSupply }}
        </div>
        <div>
          <span>流通中的总M 市值</span>
          {{ listData.mCoinTokenInfo.mCirculatingSupplyMarketCap }}
        </div>
        <div>
          <span>M 总市值</span>
          {{ listData.mCoinTokenInfo.mTotalMarketValue }}
        </div>
      </el-card>
      <el-card class="box-card" v-if="listData">
        <h3 slot="header" class="clearfix">
          系统数据L
        </h3>
        <div>
          <span>系统L总锁仓</span>
          {{ listData.luckyTokenInfo.systemTotalLockLucky }}
        </div>
        <div>
          <span>系统L总余额</span>
          {{ listData.luckyTokenInfo.systemTotalLucky }}
        </div>
        <div>
          <span>系统L总奖池</span>
          {{ listData.luckyTokenInfo.systemTotalPoolLucky }}
        </div> 
        <div>
          <span>每日最大提现</span>
          {{ listData.luckyTokenInfo.dayMaxWithdrawal }}
        </div> 
        <div>
          <span>swap已消费U</span>
          {{ listData.luckyTokenInfo.swapOutU }}
        </div> 
        <div>
          <span>swap已购买Lucky</span>
          {{ listData.luckyTokenInfo.swapInL }}
        </div> 
        
      </el-card>
      <el-card class="box-card box-cards" v-if="listData">
        <h3 slot="header" class="clearfix">
          质押详情
        </h3>
        <div v-for="(item,index) in (listData.stakeInfo)" :key="index" >
          <span v-if="item.index != 0">第{{ item.index }}期</span>
          <span v-else >锁定三期</span>
          <span>质押总数: {{ item.stakeTotal }}</span>
          <span>需要给到的奖励: {{ item.needTotalReward }}</span>
          <!-- <span>第{{ item.index }}期</span>
          <span>第{{ item.index }}期</span>
          <span>第{{ item.index }}期</span> -->
        </div>
      </el-card>

      <el-card class="box-card" v-if="listData">
        <h3 slot="header" class="clearfix">
          红包详情
        </h3>
        <div>
          <span>发送总数</span>
          {{ listData.mLuckyInfo.sendTotal }}
        </div>
        <div>
          <span>待领取</span>
          {{ listData.mLuckyInfo.waitReceive }}
        </div>
      </el-card>

      
      <el-card class="box-card" v-if="listData">
        <h3 slot="header" class="clearfix">
          解除质押详情
        </h3>
        <div>
          <span>解除质押的本金</span>
          {{ listData.unStakeInfo.unStakeTotal }}
        </div>
        <div>
          <span>解除质押给到的奖励</span>
          {{ listData.unStakeInfo.unStakeReward }}
        </div>
      </el-card>

      <el-card class="box-card" v-if="listData">
        <h3 slot="header" class="clearfix">
          C2C
        </h3>
        <div>
          <span>等待成交的 M</span>
          {{ listData.c2cInfo.waitDealM }}
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
  import { SysData } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        // rules表单验证
        listData:null, //用户数据
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取转入列表
      getdata(parameter) {
        this.loading = true
        SysData(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.listData = res.data
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 50px;
  }
  .box-card{
    width: 600px;
  }
  .box-card div{
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }
  .box-card .clearfix{
    margin: 0;
    font-size: 16px;
  }

  .box-cards div span{
    width: 33%;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/data/Sys.vue